import "./App.css";

import DefaultOpenLayout from "./components/Layout/DefaultOpenLayout/DefaultOpenLayout";
import DefaultLayout from "./components/Layout/DefaultLayout/DefaultLayout";
// provider
import AuthProvider from "./context/AuthContext";
import PimDashboardProvider from "context/PimDashboardContext";

import { rootProtectedPath, services } from "data/authData";
import DashboardWithMiniCollapsableDrawer from "components/Layout/DashboardWithMiniCollapsableDrawer/DashboardWithMiniCollapsableDrawer";
import { dashboardParamName, PimDashboardServices } from "data/globalData";
import { GlobalState } from "./context/GlobalContext";
import axios from "axios";
import { Routes, Route } from "react-router-dom";
// components
import LoadingScreen from "./components/ReusableComponents/LoadingScreen";
import Explore from "components/Explore/Explore";
import PimDashboard from "components/PimDashboard/PimDashboard";
import Users from "components/Users/Users";
import ChangePassword from "components/Auth/ChangePassword/ChangePassword";
import Login from "./components/Auth/Login/Login";
// mui
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import ForgotPasswordReset from "components/Auth/ForgotPasswordReset/ForgotPasswordReset";
import { generatePimRoutesFromServiceTree } from "components/PimDashboard/data";
import { pimDashboardMeta } from "data/pimData";

function App() {
	const { snackBar, snackBarOpen, setSnackBarOpen } = GlobalState();
	// axios defaults
	axios.defaults.baseURL = process.env.REACT_APP_RELOOK_API_URL;
	axios.defaults.headers["Content-Type"] = `application/json`;
	return (
		<Box className="App">
			<LoadingScreen />
			{/* for alert messages */}
			<Snackbar
				open={snackBarOpen}
				autoHideDuration={4000}
				onClose={() => setSnackBarOpen(false)}
				anchorOrigin={snackBar.anchorOrigin}>
				<Alert onClose={() => setSnackBarOpen(false)} severity={snackBar.severity} sx={{ width: "100%" }}>
					{snackBar.message}
				</Alert>
			</Snackbar>

			<Routes>
				<Route path="/" element={<Login />} />
				{/* only rootProtectedPath has authentication */}
				<Route
					path={rootProtectedPath}
					element={
						<AuthProvider>
							<DefaultLayout />
						</AuthProvider>
					}>
					<Route index element={<Explore />} />
					<Route path={PimDashboardServices.users.path} element={<Users />} />
					{/* <Route element={<PimDashboardProvider />}>
						{Object.keys(PimDashboardServices)
							.reduce((acc, row) => {
								const service = PimDashboardServices[row];
								if (service?.types && typeof service?.types === "object") {
									Object.keys(service.types).forEach((key) => {
										acc.push(service.types[key]);
									});
								} else acc.push(service);
								return acc;
							}, [])
							.map((row) => {
								return (
									<Route
										path={row.key}
										key={row.key}
										element={
											<DashboardWithMiniCollapsableDrawer
												drawerList={PimDashboardServices}
												searchParamName={dashboardParamName}
												navSpace={0}
												service={row}
												pathName={row.key}
											/>
										}>
										<Route index element={<PimDashboard />} />
									</Route>
								);
							})}
					</Route> */}
					<Route element={<PimDashboardProvider />} path={pimDashboardMeta.path}>
						{/* <Route index element={<Navigate to={}} replace />} /> */}
						{Object.keys(PimDashboardServices).map((key) =>
							generatePimRoutesFromServiceTree(PimDashboardServices[key], pimDashboardMeta.path)
						)}
					</Route>
				</Route>

				{/* Routes with no auth */}
				<Route path="open" element={<DefaultOpenLayout />}></Route>

				<Route path="change_password" element={<ChangePassword />} />
				<Route path="password-reset/:token" element={<DefaultOpenLayout />}>
					<Route index element={<ForgotPasswordReset />} />
				</Route>

				<Route path="external"></Route>
			</Routes>
		</Box>
	);
}

export default App;
